import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import CustomerVehicleFooter from './CustomerVehicleFooter';

// Actions
import { gtmUserEvent } from 'store/reducers/gtm/actions';
import { setAppFlow } from 'store/reducers/userInteractions/actions';
import { goTo } from 'store/reducers/navigation/actions';
import { restartVehicleFrom } from 'store/reducers/appointment/actions';

export default compose(
  injectIntl,
  connect(
    null,
    {
      gtmUserEvent,
      setAppFlow,
      goTo,
      restartVehicleFrom
    }
  )
)(CustomerVehicleFooter);



// WEBPACK FOOTER //
// ./src/components/molecules/CustomerVehicleFooter/CustomerVehicleFooterContainer.js